<template>
  
  <div @click.stop class="dropdown-button" tabindex="1" @blur="close">
    <div class="rounded flex-button mx-3">
      <slot name="primary">Primary</slot>
      <div @click="toggle" class="arrow-container">
        <div class="arrow down" title="Click For More Options"></div>
      </div>
    </div>
    <slot />
  </div>
</template>
<style>
.dropdown-button {
  margin: 0.5rem 0 0.5rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  
}
.flex-button {
  margin: 0.5rem 0 0 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  width: 11rem;
  height: 3rem;
  padding: 0;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.2);
}

.button-label {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
  background-color: rgb(52, 148, 148);
  font-size: 1rem;
  font-weight: 500;
  color: white;
  width: 8rem;
  border-radius: 0.375rem 0 0 0.375rem;
}
.dollar-sign {
  font-size: 1.5rem;
}
.button-label:hover {
  background-color: rgb(0, 85, 86, 0.8);
}
.arrow-container {
  width: 3rem;
  background-color: rgb(52, 148, 148);
  border-left: 0.1rem solid rgb(185, 217, 216);
  border-radius: 0 0.375rem 0.375rem 0;
}
.arrow {
  border: solid white;
  border-width: 0 0.15rem 0.15rem 0;
  display: inline-block;
  padding: 0.25rem;
}
.arrow-container:hover {
  background-color: rgb(0, 85, 86, 0.8);
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  margin-top: 1.25rem;
}

.down {
  margin: 1rem;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
</style>
<script>
export default {
  name: "SplitButton",
  provide() {
    return {
      sharedState: this.sharedState,
    };
  },
  data() {
    return {
      sharedState: {
        active: false,
      },
    };
  },
  methods: {
    toggle: function() {
      this.sharedState.active = !this.sharedState.active;
    },
    close() {
      setTimeout(() => {
        this.sharedState.active = false;
      }, 150);
    },
  },
};
</script>
